module.exports = __webpack_public_path__ + "img/registration.2966178f.svg";